import React from "react";
import "./ConfirmPay.scss";

export const ConfirmPay = ({ paymentMethod, cumulativeOffer }) => {
  const amount = cumulativeOffer.cost;

  return (
    <div className="confirm-pay">
      {paymentMethod === "online" && (
        <>
          <h1 className="confirm-pay__title">{"Confirm & Pay"}</h1>
          <p>
            The host requires a payment of {`£${amount}`} to finalise your
            booking. Follow the link below to pay using our secure payment
            service and confirm this venue for your event.
          </p>
        </>
      )}

      {paymentMethod === "offline" && (
        <>
          <h1 className="h3">Confirm your booking</h1>
          <p>
            You're all set to go! Click book below to confirm your interest in
            booking this venue. The host will let you know the details of any
            payment required to confirm the booking.
          </p>
        </>
      )}
    </div>
  );
};
